import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import newsData from "../data/newsData";
import { useParams } from "react-router-dom";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
export default function NewsDetails() {
    const { t } = useTranslation();
    useScrollAnimation();
    const { id } = useParams();
    const news = newsData.find(item => item.id === id);
    if (!news) {
        return <div className="text-center text-red-500">{t("News not found")}</div>;
    }
    return (
        <>
            <section className="landingpages">
                <div className="container h-full flex flex-col items-center justify-center text-center">
                    <div className="btmAni1256 text-[#017E89] font-bold text-[35px] capitalize">{t("News & Event")}</div>
                    <div className="btmAni2000 flex items-center gap-[5px] font-bold">
                        <Link to={"/"}>{t("Home")}</Link> -
                        <span className="text-[#017E89] capitalize">{t("News & Event")}</span>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[50px]">
                    <div className="btmAni25002 w-full h-[350px]">
                        <img className="w-[100%] h-[100%] object-cover rounded-[8px]" src={news.image} alt={news.name} />
                    </div>
                    <div className="flex flex-col gap-[25px]">
                        <div className="flex items-center justify-between">
                            <div className="js-scroll fade-top flex items-baseline gap-[7px]">
                                <img className="w-[35px] h-auto" src={require("../../assets/icons/lineTitle.svg").default} alt="" />
                                <div className="font-bold capitalize text-[25px] text-[#017e89]">{t(`${news.title}`)}</div>
                            </div>
                            <div className="js-scroll fade-top flex items-center gap-[5px]">
                                <img className="w-[20px] h-[20px]" src={require("../../assets/icons/calender.svg").default} alt="" />
                                <div className="font-bold text-[#017E89]">{news.data}</div>
                            </div>
                        </div>
                        <p className="js-scroll fade-btm">
                            {news.description}
                        </p>
                    </div>
                </div>
            </section>
        </>
    );
}